<template>
  <div class="FilterComponent">
    <div class="title-container">
      <div class="FilterComponent__button-states" v-if="!designerView">
          <div class="btns-wrap" >
            <button
                v-if="accountView"
                :disabled="(possibleToSend) ? false : true"
                @click="sendToClients()"
                class="btn btn-primary"
            >
              send creatives
            </button>
            <button
                v-if="accountView"
                :disabled="(haveNeedMoreInfo) ? false : true"
                @click="notifyClient()"
                class="btn btn-secondary "
            >
            send info requests
            </button>
            <button
                v-if="accountView"
                @click="resendEmailToClient()"
                class="btn btn-secondary "
            >
            Resend e-mail to client
            </button>
            <button
                v-if="!accountView && canComment"
                @click="sendToAccount()"
                class="btn btn-primary "
            >
              done with commenting
            </button>
            <div class="commenting-not-allowed" v-if="!accountView  && !canComment">
              commenting is closed
            </div>
          </div>
          <div class="btns-states-info" >
            <div v-if="!accountView && canComment">You can comment on the creatives or approve them. Makes sure to click the “done with commenting” button after you’re done.</div>
            <div v-if="!accountView  && !canComment">The agency is preparing some new versions or replying your comments. Wait until the next round.</div>

            <div v-if="accountView  && canComment && !possibleToSend">You can upload new creatives, new versions, or reply the clients comments.</div>
            <!--div v-if="accountView && !possibleToSend && !canComment && !haveNeedMoreInfo">Wait for the client to comment on creatives or approve them.</div>-->
            <div v-if="accountView && haveNeedMoreInfo">You have some comments you need further clarification on. Click the “send info requests” button to send a notification to the client.</div>
            <div v-if="accountView && isCreativeOnClient">Wait for the client to comment on creatives or approve them. You can upload new verisons of the creatives in “on agency” status, or upload new creatives too.</div>
          </div>
      </div>
      <div class="filters" v-if="!designerView">
        <ul >
          <li
              class="filter"
              v-bind:class="{ active: status.readyToSend && status.inProgress && status.approved && status.onClient }"
          >
            <input v-if="!status.readyToSend || !status.inProgress || !status.approved || !status.onClient"
                   class="styled-checkbox" id="styled-checkbox-1" type="checkbox" value="value1"
                   :checked="status.readyToSend && status.inProgress && status.approved && status.onClient"
                   @change="status.readyToSend = true; status.inProgress = true; status.approved = true;
                   status.onClient =true"/>
            <label v-if="!status.readyToSend || !status.inProgress || !status.approved || !status.onClient" for="styled-checkbox-1">All</label>
            <input v-if=" status.readyToSend && status.inProgress && status.approved && status.onClient"
                   class="styled-checkbox" id="styled-checkbox-2" type="checkbox" value="value1"
                   :checked="status.readyToSend && status.inProgress && status.approved && status.onClient"
                   @change="status.readyToSend = false; status.inProgress = false; status.approved = false;
                   status.onClient =false"/>
            <label v-if=" status.readyToSend && status.inProgress && status.approved && status.onClient" for="styled-checkbox-2">All</label>
          </li>

          <li
              class="filter"
              v-bind:class="{ active: status.inProgress }"

          >
            <input
                class="styled-checkbox"
                id="styled-checkbox-3"
                type="checkbox"
                value="value2"
                v-model="status.inProgress"
            />
            <label for="styled-checkbox-3">On Agency</label>
          </li>

          <li v-if="accountView"
              class="filter"
              v-bind:class="{ active: status.readyToSend }"
          >
            <input class="styled-checkbox" id="styled-checkbox-4" type="checkbox" value="value3"
                   v-model="status.readyToSend"/>
            <label for="styled-checkbox-4">Ready to send</label>
          </li>

          <li
              class="filter"
              v-bind:class="{ active: status.onClient }"
          >
            <input class="styled-checkbox" id="styled-checkbox-5" type="checkbox" value="value4"
                   v-model="status.onClient"/>
            <label for="styled-checkbox-5">On client</label>
          </li>

          <li
              class="filter"
              v-bind:class="{ active: status.approved }"
          >
            <input class="styled-checkbox" id="styled-checkbox-6" type="checkbox" value="value5"
                   v-model="status.approved"/>
            <label for="styled-checkbox-6">Approved</label>
          </li>
          <li
              class="filter"
              v-bind:class="{ active: status.rejected }"
          >
            <input class="styled-checkbox" id="styled-checkbox-7" type="checkbox" value="value6"
                   v-model="status.rejected"/>
            <label for="styled-checkbox-7">Rejected</label>
          </li>
        </ul>
      </div>
      <!-- BUTTONS -->
    

      <div class="ppcThumbnail">
        <div class="cards row margin-medium--bottom flex-wrap-wrap">
          <PPCThumbnailCard
              class="thumbnailCardWrapper margin"
              v-for="(P, index) in filteredCreatives"
              :key="index"
              :creative="(P.status == 'draft' && !accountView && P.child) ? P.child : P"
              :child="(P.status == 'draft' && !accountView && P.child) ? true :false"
              :board="board"
              :index="index"
              :accountView="accountView"
              :designerView="designerView"
          />

          <addCreative :cardMode="true"
                       v-if="accountView || designerView"
                       ref="add_new_crea"
                       :board="board"
          />

        </div>
        
        
      </div>
    </div>
    <approveUncommented :showDialog="showApproveUncommented" />
  </div>
</template>

<style scoped>
</style>

<script>
import PPCThumbnailCard from "@/components/PPCThumbnailCard";
import addCreative from "@/components/pagesComponents/brand/addCreative.vue";
import approveUncommented from "./approveUncommented";
export default {
  components: {
    PPCThumbnailCard, addCreative,approveUncommented
  },
  props: ["selected", "board", "campaign", "brand", "accountView","designerView"],

  data: () => {
    return {
      currentFilter: "ALL",
      showApproveUncommented : false,
      approveAllUncommented : false,
      statusorder: {
        draft: 1,
        live: 2,
        done: 3,
        rejected: 4
      },
      status: {
        inProgress: localStorage.approveele_inProgress !='false'  ,
        readyToSend: localStorage.approveele_readyToSend !='false' ,
        approved: localStorage.approveele_approved !='false' ,
        onClient: localStorage.approveele_onClient !='false' ,
        rejected:  localStorage.approveele_rejected !='false',
      }
    };
  },

  computed: {
    isCreativeOnClient(){
      if (!this.board.creative) {
        return false;
      }
      return this.board.creative.filter(s => {
        
        return (s.status == 'live' && s.comment_status == "client" )
      }).length > 0
    },
    possibleToSend(){
      //console.log('POSSIBLE',this.board.creative.length )
      if (!this.board.creative) {
        return false;
      }
      return this.board.creative.filter(s => {
        return ((s.status == 'live' && s.comment_status == "need_more_info") || s.status == 'rejected' || (s.status == 'live' && s.comment_status == "client") || s.status == 'draft' || s.status == 'done')
      }).length == this.board.creative.length
    },
    haveNeedMoreInfo(){
       if (!this.board.creative) {
        return false;
      }
      return this.board.creative.filter(s => {
        return s.status == 'live' && s.comment_status == "need_more_info"
      }).length > 0
    },
    filteredCreatives() {
      var _this = this;
      if (!this.board.creative) {
        return [];
      }
      return this.board.creative.filter(c => {
        localStorage.approveele_inProgress = this.status.inProgress;
        localStorage.approveele_approved = this.status.approved;
        localStorage.approveele_onClient = this.status.onClient;
        localStorage.approveele_readyToSend = this.status.readyToSend;
        localStorage.approveele_rejected = this.status.rejected;
        const s = this.getStatus(c.status, c.comment_status);
        var show = true;
        if (this.$store.state.user.user_type == 'designer')
        {
          show = parseInt(c.internal) == 1
        }
        if (this.$store.state.user.user_type == 'client')
        {
          show = parseInt(c.internal) == 0
        }
        show = parseInt(c.internal) == 0;
        return show && (s === 'ONAGENCY' && this.status.inProgress ||
            s === 'APPROVED' && this.status.approved ||
            s === 'ONCLIENT' && this.status.onClient ||
            s === 'READYTOSEND' && this.status.readyToSend ||
            s === 'REJECTED' && this.status.rejected);
      }).sort(function(a,b) {
        if (a.status != a.status)
        {
          return _this.statusorder[a.status ]-_this.statusorder[b.status];
        }
        else
        {
          return b.id - a.id;
        }
      })
    },
    filteredProject: function () {
      var ret = [];
      for (var i = 0; i < this.projects.length; i++) {
        if (
            this.currentFilter === this.projects[i].category ||
            this.currentFilter === "ALL"
        ) {
          ret.push(this.projects[i]);
        }
      }
      //console.log(ret);
      return ret;
    },
    canComment() {
      var ret = false;
      if (this.board.creative){
        for (var i = 0; i < this.board.creative.length; i++) {
          if (this.board.creative[i].comment_status == "client") {
            ret = true;
          }
        }
      }
      
      return ret;
    },
  },
  methods: {
    getStatus(status, commentStatus) {
      if (status === "draft") {
        return "READYTOSEND";
      }
      if (status === "rejected") {
        return "REJECTED";
      }
      if (status === "live") {
        if (commentStatus === "account") return "ONAGENCY";
        if (commentStatus === "need_more_info") return "ONAGENCY";
        if (commentStatus === "client") return "ONCLIENT";
        if (commentStatus === "done") return "ONAGENCY";
      }
      if (status === "done") {
        return "APPROVED";
      }
      return "";
    },
    selectCreative(creative) {
      //console.log("thisisit", creative);
      this.$router.push("/board/" + this.board.slug + "/" + creative);
    },
    selectCreativeById(id){

      
       for (var i = 0; i< this.board.creative.length; i++){
         console.log('xxxx',this.board.creative[i].id , id)
         if (this.board.creative[i].id == id || (this.board.creative[i].child && this.board.creative[i].child.id == id)){
           this.$router.push("/board/" + this.board.slug + "/" + i);
         }
       }
     },
    sendToAccount: function () {
      
      if (!this.approveAllUncommented )
      {
        var uncommented = 0;
        for (var i = 0; i < this.board.creative.length; i++) {
          var creative = this.board.creative[i];
          console.log(creative);
          if (creative.status != "done" && creative.status != "rejected" && creative.parent_id == 0 && creative.comment_status == 'client') {
            var commented = false;
            if ( !creative.comment)
            {
              commented = false;
            }
            else
            {
              if ( creative.comment.slice(-1)[0].user.user_type == 'client')
              {
                commented = true;
              }
            }
            if (!commented)
            {
              uncommented++;
            }
          }
        }
        if (uncommented > 0)
        {
          this.showApproveUncommented = true;
          return
        }
      }
      
      console.log('save');
      this.approveAllUncommented = false;
       var _this = this;
        for ( i = 0; i < this.board.creative.length; i++) {
         creative = this.board.creative[i];
        if (creative.status != "done"&&  creative.status != "rejected" && creative.parent_id == 0 && creative.comment_status == 'client') {
           commented = false;
            if ( !creative.comment)
            {
              commented = false;
            }
            else
            {
              for (var j=0; j <  creative.comment.length; j++)
              {
                console.log(creative.comment[j].user.user_type)
                if (creative.comment[j].user.user_type == 'client')
                {
                  commented = true;
                }
              }
            }
          if (creative.comment)
          {
            for ( j=0; j < creative.comment.length; j++)
            {
              if (creative.comment[j].user.user_type == 'account')
              {
                this.put('comment/'+creative.comment[j].id,{status : 'close'},{});
              }
              if (creative.comment[j].user.user_type == 'client' && creative.comment[j].status == 'open' && creative.comment[j].reply_to != 0)
              {
                this.put('comment/'+creative.comment[j].reply_to,{status : 'open'},{});
              }
            }
          }
          _this.addLog({
            creative_id: _this.board.creative[i].id,
            payment_cluster_id: _this.board.creative[i].payment_cluster_id,
            creative_name: _this.board.creative[i].type == "image" ? _this.board.creative[i].width + 'x' + _this.board.creative[i].height : _this.board.creative[i].type,
            board_id: _this.board.creative[i].board.id,
            board_name: _this.board.creative[i].board.name,
            campaign_id: _this.board.creative[i].board.campaign_id,
            campaign_name: _this.board.campaign.name,
            brand_id: _this.brand.id,
            brand_name: _this.brand.name,
            client_id: _this.brand.client.id,
            client_name: _this.brand.client.name,
            action: (commented) ? "Done with Comment" : "Approved",
            user_id: _this.$store.state.user.id,
            user_name: _this.$store.state.user.name
          }, function () {
            _this.refreshTimeline();
          })
          _this.put(
              "creative/" + creative.id,
              {
                status: (commented) ? "live" : 'done',
                board_id: _this.board.id,
                comment_status: "account",
              },
              {}, function () {
                  if (_this.$parent.refreshBrand) _this.$parent.refreshBrand();
              }
          );
        }
      }
      if (this.board.user) {
        for (i = 0; i < this.board.user.length; i++) {
          if (this.board.user[i].user_type != "client") {
            _this.post(
                "emailsender/3/1",
                {
                  to: this.board.user[i].email,
                  data_replace: {
                    recipient_name: this.board.user[i].name,
                    brand: this.brand.name,
                    campaign: this.campaign.name,
                    board: this.board.name,
                    name: this.board.user[i].name,
                    board_slug: this.board.slug,
                  },
                },
                {},
                
            );
          }
        }
      }
    }
    ,
    notifyClient(){
      var _this = this;
      for (var i = 0; i < this.board.creative.length; i++) {
        var creative = this.board.creative[i];
        if (creative.comment_status == "need_more_info") {
          if (creative.comment)
          {
            for (var j=0; j < creative.comment.length; j++)
            {
              if (creative.comment[j].user.user_type == 'client')
              {
                this.put('comment/'+creative.comment[j].id,{status : 'close'},{});
              }
              if (creative.comment[j].user.user_type == 'account' && creative.comment[j].status == 'open' && creative.comment[j].reply_to != 0)
              {
                this.put('comment/'+creative.comment[j].reply_to,{status : 'open'},{});
              }
            }
          }
          _this.addLog({
            creative_id: _this.board.creative[i].id,
            payment_cluster_id: _this.board.creative[i].payment_cluster_id,
            creative_name: _this.board.creative[i].type == "image" ? _this.board.creative[i].width + 'x' + _this.board.creative[i].height : _this.board.creative[i].type,
            board_id: _this.board.creative[i].board.id,
            board_name: _this.board.creative[i].board.name,
            campaign_id: _this.board.creative[i].board.campaign_id,
            campaign_name: _this.board.campaign.name,
            brand_id: _this.brand.id,
            brand_name: _this.brand.name,
            client_id: _this.brand.client.id,
            client_name: _this.brand.client.name,
            action: "Need further information",
            user_id: _this.$store.state.user.id,
            user_name: _this.$store.state.user.name
          }, function () {
            _this.refreshTimeline();
          })
          _this.put(
              "creative/" + creative.id,
              {
                status: "live",
                comment_status: "client",
              },
              {}, function () {
                  if (_this.$parent.refreshBrand) _this.$parent.refreshBrand();

              }
          );
        }
      }
      if (this.board.user) {
        for (i = 0; i < this.board.user.length; i++) {
          if (this.board.user[i].user_type === "client") {
            _this.post(
                "emailsender/2/1",
                {
                  to: this.board.user[i].email,
                  data_replace: {
                    board_slug: this.board.slug,
                    recipient_name: this.board.user[i].name,
                    brand: this.brand.name,
                    campaign: this.campaign.name,
                    board: this.board.name,
                    name: this.$store.state.user.name,
                  },
                },
                {}
               
            );
          }
        }
      }
    },
    resendEmailToClient: function(){
      var _this = this;
      if (this.board.user) {
        for (var i = 0; i < this.board.user.length; i++) {
          if (this.board.user[i].user_type === "client") {
            _this.post(
                "emailsender/2/1",
                {
                  to: this.board.user[i].email,
                  data_replace: {
                    recipient_name: this.board.user[i].name,
                    board_slug: this.board.slug,
                    brand: this.brand.name,
                    campaign: this.campaign.name,
                    board: this.board.name,
                    name: this.$store.state.user.name,
                  },
                },
                {}
               
            );
          }
        }
      }
    },
    sendToClients: function () {
      var _this = this;
      for (var i = 0; i < this.board.creative.length; i++) {
        var creative = this.board.creative[i];
        if (creative.status !== "done" && creative.status != "rejected") {
          if (creative.comment)
          {
            for (var j=0; j < creative.comment.length; j++)
            {
              if (creative.comment[j].user.user_type == 'client')
              {
                this.put('comment/'+creative.comment[j].id,{status : 'close'},{});
              }
              if (creative.comment[j].user.user_type == 'account' && creative.comment[j].status == 'open' && creative.comment[j].reply_to != 0)
              {
                this.put('comment/'+creative.comment[j].reply_to,{status : 'open'},{});
              }
            }
          }
          _this.addLog({
            creative_id: _this.board.creative[i].id,
            payment_cluster_id: _this.board.creative[i].payment_cluster_id,
            creative_name: _this.board.creative[i].type == "image" ? _this.board.creative[i].width + 'x' + _this.board.creative[i].height : _this.board.creative[i].type,
            board_id: _this.board.creative[i].board.id,
            board_name: _this.board.creative[i].board.name,
            campaign_id: _this.board.creative[i].board.campaign_id,
            campaign_name: _this.board.campaign.name,
            brand_id: _this.brand.id,
            brand_name: _this.brand.name,
            client_id: _this.brand.client.id,
            client_name: _this.brand.client.name,
            action: "Sent to Approval",
            user_id: _this.$store.state.user.id,
            user_name: _this.$store.state.user.name
          }, function () {
            _this.refreshTimeline();
          })
          _this.put(
              "creative/" + creative.id,
              {
                status: "live",
                board_id: _this.board.id,
                comment_status: "client",
              },
              {}, function () {
                  if (_this.$parent.refreshBrand) _this.$parent.refreshBrand();

              }
          );
        }
      }
      if (this.board.user) {
        for (i = 0; i < this.board.user.length; i++) {
          if (this.board.user[i].user_type === "client") {
            _this.post(
                "emailsender/2/1",
                {
                  to: this.board.user[i].email,
                  data_replace: {
                    recipient_name: this.board.user[i].name,
                    board_slug: this.board.slug,
                    brand: this.brand.name,
                    campaign: this.campaign.name,
                    board: this.board.name,
                    name: this.$store.state.user.name,
                  },
                },
                {}
               
            );
          }
        }
      }
    }
    ,
    refreshBrand() {
      //console.log("filter")
      if (this.$parent.refreshBrand) this.$parent.refreshBrand();
    }
    ,
    setFilter: function (filter) {
      this.currentFilter = filter;
      //console.log(filter);
    }
    ,
  }
  ,
}
;
</script>
    